<template>
  <a-form
    :form="form"
    :label-col="{ span: 5 }"
    :wrapper-col="{ span: 12 }"
    @submit="handleSubmit"
  >
    <a-form-item label="Название">
      <a-input
        v-decorator="[
          'name',
          {
            rules: [{ required: true, message: 'Впишите название столбца' }],
          },
        ]"
      />
    </a-form-item>
    <a-form-item label="Порядок">
      <a-input
        v-decorator="[
          'order',
          {
            rules: [{ required: true, message: 'Впишите цифру' }],
          },
        ]"
      />
    </a-form-item>
    <a-form-item label="Статусы">
      <multiselect
        v-model="addedStatuses"
        tag-placeholder="Добавьте статусы"
        placeholder="Добавьте статусы"
        label="name"
        track-by="uniqId"
        :options="multiselectStatuses"
        :multiple="true"
        :taggable="false"
        deselect-label="Удалить"
        select-label="Добавить"
      ></multiselect>
    </a-form-item>
    <a-form-item label="Тип">
      <a-select
        v-decorator="[
          'type',
          {
            rules: [{ required: true, message: 'Выберите тип' }],
          },
        ]"
        @change="handleTypeChange"
      >
        <a-select-option value="counter">
          Счетчик переходов в статус
        </a-select-option>
        <a-select-option value="sum">
          Сумма бюджетов
        </a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item label="Обнулять">
      <a-select
        v-decorator="[
          'nulled',
          {
            rules: [{ required: true, message: 'Укажите' }],
          },
        ]"
        @change="handleScheduleTypeChange"
      >
        <a-select-option value="daily">
          Ежедневно
        </a-select-option>
        <a-select-option value="weekday">
          В день недели
        </a-select-option>
        <a-select-option value="monthday">
          В дни месяца
        </a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item label="В" v-if="nulled === 'weekday'">
      <a-select
        v-decorator="[
          'addedWeekday',
          {
            rules: [{ required: true, message: 'Укажите' }],
          },
        ]"
      >
        <a-select-option value="1">
          Понедельник
        </a-select-option>
        <a-select-option value="2">
          Вторник
        </a-select-option>
        <a-select-option value="3">
          Среда
        </a-select-option>
        <a-select-option value="4">
          Четверг
        </a-select-option>
        <a-select-option value="5">
          Пятница
        </a-select-option>
        <a-select-option value="6">
          Суббота
        </a-select-option>
        <a-select-option value="7">
          Воскресенье
        </a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item label="В день:" v-if="nulled === 'monthday'">
      <multiselect
        v-model="addedMonthDays"
        tag-placeholder="Добавьте дни месяца"
        placeholder="Добавьте дни месяца"
        label="name"
        track-by="code"
        :options="monthDays"
        :multiple="true"
        :taggable="false"
        deselect-label="Удалить"
        select-label="Добавить"
      ></multiselect>
    </a-form-item>
    <a-form-item label="Время обнуления">
      <a-select
        v-decorator="[
          'nullTime',
          {
            rules: [{ required: true, message: 'Укажите' }],
          },
        ]"
      >
        <a-select-option value="0">
          0:00
        </a-select-option>
        <a-select-option value="8">
          8:00
        </a-select-option>
        <a-select-option value="10">
          10:00
        </a-select-option>
        <a-select-option value="11">
          11:00
        </a-select-option>
        <a-select-option value="12">
          12:00
        </a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
      <a-button type="primary" html-type="submit" style="margin-right: 8px;">
        {{ formType === 'new' ? 'Добавить' : 'Сохранить' }}
      </a-button>
       <a-button type="danger" v-if="formType === 'edit'" @click="deleteColumn()">
        Удалить столбец
      </a-button>
    </a-form-item>
  </a-form>
</template>
<script>
import bent from 'bent';
import Multiselect from 'vue-multiselect';

export default {
  props: [
    'initialData',
    'baseUrl',
    'statuses',
    'formType',
    'panelId',
    'password',
    'adminpassword',
  ],
  components: {
    Multiselect,
  },
  data() {
    return {
      addedStatuses: [],
      addedMonthDays: [],
      type: null,
      nulled: null,
      monthDays: [
        { name: '1-го числа', code: '1' },
        { name: '15-го числа', code: '15' },
      ],
      formLayout: 'horizontal',
      form: this.$form.createForm(this, { name: 'coordinated' }),
      modalTitle: null,
      post: {},
    };
  },
  async mounted() {
    this.post = bent(this.baseUrl, 'POST', 'json', 200);
    this.init();
  },
  computed: {
    multiselectStatuses() {
      console.log('statuses ready');
      const ms = [];
      for (const pipeline of this.statuses) {
        ms.push({
          name: pipeline.name,
          $isDisabled: true,
        });
        for (const status of pipeline.statuses) {
          ms.push({
            name: status.name,
            code: status.id,
            uniqId: status.id+'_'+pipeline.id,
            status: { id: Number(status.id), pipelineId: Number(pipeline.id) },
          });
        }
      }
      return ms;
    },
  },
  watch: {
    initialData(value) {
      this.type = value.type
      this.nulled = value.nulled
      setTimeout(() => {
        this.form.setFieldsValue(value);
        this.addedStatuses = value.addedStatuses.map(status => {
          return {
            name: status.name,
            code: status.code,
            status: status.status,
            uniqId: status.status.id + '_' + status.status.pipelineId
          };
        })
        this.addedMonthDays = value.addedMonthDays;
      }, 0)
      
    },
  },
  methods: {
    async init() {
      this.type = this.initialData.type
      this.nulled = this.initialData.nulled
      setTimeout(() => {
        this.form.setFieldsValue(this.initialData);
        this.addedStatuses = this.initialData.addedStatuses.map(status => {
          return {
            name: status.name,
            code: status.code,
            status: status.status,
            uniqId: status.status.id + '_' + status.status.pipelineId
          }
        });
        this.addedMonthDays = this.initialData.addedMonthDays;
      }, 0) 
    },
    async addColumnToDb(column) {
      console.log('add column to db', column);
      try {
        await this.post('addColumn', {
          panelId: this.panelId,
          password: this.password,
          adminpassword: this.adminpassword,
          column,
          formType: this.formType
        });
      } catch (error) {
        console.log(error);
        alert('Ошибка сохранения');
      }
    },
    async deleteColumn() {
      if (!this.initialData._id) return this.$emit('statusChange');
      await this.post('deleteColumn', {
        panelId: this.panelId,
        password: this.password,
        adminpassword: this.adminpassword,
        column: this.initialData._id
     })
     this.$emit('statusChange');
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          if (!this.addedStatuses.length) {
            alert('Добавьте статусы');
            return;
          } else {
            await this.addColumnToDb({
              _id: this.initialData._id,
              ...values,
              addedStatuses: this.addedStatuses,
              addedMonthDays: this.addedMonthDays,
            });
            this.$emit('statusChange');
          }
        }
      });
    },
    handleTypeChange(value) {
      this.type = value;
    },
    handleScheduleTypeChange(value) {
      this.nulled = value;
    }
  },
};
</script>
<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
.table-operations {
  margin-bottom: 16px;
}

.table-operations > button {
  margin-right: 8px;
}

.dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #999;
  transition: all 0.3s;
}
.dynamic-delete-button:hover {
  color: #777;
}
.dynamic-delete-button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>
